import React from 'react';

class CalculatorCallToActionCard extends React.Component {
  showWidget() {
    window.Calendly.showPopupWidget('https://calendly.com/yard_au');
  }
  applyNow() {
    window.location.assign(`${window.location.protocol}//${window.location.host}/onboarding_funnel/new`);
  }
  
  render() {
    const { isDreamSpace } = this.props;
    const className = isDreamSpace ? 'dreamspace' : '';

    return (
      <div className={`calculator-call-to-action-card ${className}`}>
        <div className="calculator-call-to-action-card__grid">
          <div className={`calculator-call-to-action-card__content ${className}`}>
            {this.props.children}
          </div>
          <div className="calculator-call-to-action-card__buttons">
            <button className={`apply-button ${className}`} onClick={this.applyNow}>Apply now</button>
            <button className={`talk-to-expert-button ${className}`} onClick={this.showWidget}>Talk to an expert</button>
          </div>
        </div>
        
        
      </div>
    )
  }
}

export default CalculatorCallToActionCard;
